<template>
    <div class="row">
        <div class="col-md-9">
            <h2>Parts</h2>
        </div> 
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-6">
                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <label for="company">Company</label>
                            <input type="text" id="company" value="" placeholder="Company" />
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="name">Your name<span class="required">*</span></label>
                            <input type="text" id="name" value="" placeholder="Your name" />
                        </div>
                        <div class="form-group col-md-6">
                            <label for="email">Email<span class="required">*</span></label>
                            <input type="email" id="email" value="" placeholder="Email" />
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="phone">Phone</label>
                            <input type="text" id="phone" value="" placeholder="Phone" />
                        </div>
                        <div class="form-group col-md-6">
                            <label for="fax">Fax</label>
                            <input type="text" id="fax" value="" placeholder="Fax" />
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <label for="message">Message</label>
                            <textarea name="message" id="message" cols="3" rows="3" placeholder="Message"></textarea>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-row">
                        <div class="form-group col-md-6 two-checkbox">
                            <label>Age of Part<span class="required">*</span></label>
                            <span>
                                <input type="checkbox" value="new" id="new" />
                                <label for="new">New</label>
                            </span>
                            <span>
                                <input type="checkbox" value="old" id="old" />
                                <label for="old">Old</label>
                            </span>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="year">Year<span class="required">*</span></label>
                            <input type="text" id="year" value="" placeholder="Year" />
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="make">Make<span class="required">*</span></label>
                            <input type="text" id="make" value="" placeholder="Make" />
                        </div>
                        <div class="form-group col-md-6">
                            <label for="model">Model<span class="required">*</span></label>
                            <input type="text" id="model" value="" placeholder="Model" />
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="chassis">Chassis<span class="required">*</span></label>
                            <input type="text" id="chassis" value="" placeholder="Chassis" />
                        </div>
                        <div class="form-group col-md-6">
                            <label for="transmission">Transmission<span class="required">*</span></label>
                            <input type="text" id="transmission" value="" placeholder="Transmission" />
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <label for="part-number">Part Number</label>
                            <input type="text" id="part-number" value="" placeholder="Part Number" />
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <button type="submit" class="btn">Send Request</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>



// WEBPACK FOOTER //
// resources/js/components/PartsSearch.vue